import { render, staticRenderFns } from "./aiFake.vue?vue&type=template&id=5ac06743&scoped=true"
import script from "./aiFake.vue?vue&type=script&lang=js"
export * from "./aiFake.vue?vue&type=script&lang=js"
import style0 from "./aiFake.vue?vue&type=style&index=0&id=5ac06743&prod&scoped=true&lang=scss"
import style1 from "./aiFake.vue?vue&type=style&index=1&id=5ac06743&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac06743",
  null
  
)

export default component.exports